<template>
  <div class="column-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <table-search
        add-text="新增栏目"
        :style="{ float: 'right' }"
        @onSearch="onSearch"
        @onChange="onChange"
        @editAndAdd="handleAdd"
      />
    </div>
    <div class="global-table-container">
      <div class="recommend-btn-container">
        <a-button
          type="primary"
          class="recommend-btn"
          :loading="recommendLoading"
          @click="handleRecommend"
        >
          推荐
        </a-button>
        <a-button
          type="primary"
          :loading="norecommendLoading"
          @click="handleNorecommend"
        >
          取消推荐
        </a-button>
        <span
          v-show="isShowError"
          class="errorMsg"
        >请至少选择一项</span>
      </div>

      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :pagination="false"
        :row-selection="{
          selectedRowKeys,
          onChange:onchangeCheck,
        }"
        children-column-name="child_list"
        :row-key="record => record.id"
      >
        <template
          slot="list_order"
          slot-scope="text, record"
        >
          <editable-cell
            :text="text"
            @change="onCellChange(record.id, 'list_order', $event)"
          />
        </template>
        <template
          slot="status"
          slot-scope="text, record"
        >
          <a-tag color="blue">
            {{ record.is_show===1?'启用':'禁用' }}
          </a-tag>
          <a-tag
            color="blue"
          >
            {{ record.recommended===1?'推荐':'未推荐' }}
          </a-tag>
        </template>
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            v-if="record.parent_id==0"
            href="javascript:;"
            @click="() => handleAdd(record)"
          >添加子分类</a>
          <a-divider
            v-if="record.parent_id==0"
            type="vertical"
          />
          <a
            href="javascript:;"
            @click="() => handleEdit(record)"
          >编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            :text="record.is_show===1?'禁用':'启用'"
            :alert-title="record.is_show===1?'确定禁用？':'确定启用？'"
            @onDelete="() => onConfirm(record)"
          />
          <a-divider type="vertical" />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
    <add-edit-modal
      ref="formRef"
      :title="title"
      :visible="visible"
      :disabled="disabled"
      :btn-is-loading="btnIsLoading"
      @onCancel="onCancel"
      @handleSubmit="handleSubmit"
    />
  </div>
</template>
<script>
import { columns } from './data/index';
import addEditModal from './modal/index';
import TableSearch from './components/search';
export default {
  components: { addEditModal, TableSearch},
  data() {
    return {
      columns,
      data: [],
      loading: false,
      btnIsLoading: false,
      title: '',
      visible: false,
      disabled: true,
      id: '',
      isShowError: false,
      selectedRowKeys: [],
      recommendLoading: false,
      norecommendLoading: false,
      department_id: '',
      keyword: '',
    };
  },
  async mounted() {
    // 获取表格数据
    await this.getTableData({ keyword: this.keyword, department_id: this.department_id});
  },
  methods: {
    // 递归处理
    dealData(data) {
      data.forEach((item) => {
        if (item.child_list && item.child_list.length > 0) {
          this.dealData(item.child_list);
        } else {
          item.child_list = undefined;
        }
      });
      return data;
    },
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post('/groups/adminGetList', params);
      if (result.data.status === 1) {
        this.loading = false;
        let data = result.data.data.data_list;
        this.data = this.dealData(JSON.parse(JSON.stringify(data)));
      }
    },
    // 搜索
    onSearch(value) {
      this.keyword = value;
      this.getTableData({ keyword: this.keyword, department_id: this.department_id });
    },
    // 下拉选择
    onChange(value){
      this.department_id=value;
      this.getTableData({ keyword: this.keyword, department_id: this.department_id });
    },
    // 新增、子栏目
    handleAdd(record) {
      this.visible = true;
      this.disabled = true;
      this.id = undefined;
      if (!record) {
        this.title = '新增栏目';
        this.$nextTick(() => {
          this.$refs.formRef.$refs.basicForm.form.setFieldsValue({
            parent_id: '0',
          });
        });
      } else {
        this.title = '新增子栏目';
        this.$nextTick(() => {
          this.$refs.formRef.$refs.basicForm.form.setFieldsValue({
            parent_id: String(record.id),
          });
        });
      }
    },
    // 编辑
    handleEdit(record) {
      console.log('handleEdit -> record', record);
      this.visible = true;
      this.disabled = false;
      this.title = '编辑栏目';
      this.id = record.id;
      let data = {
        parent_id: String(record.parent_id),
        name: record.name,
        department_id: String(record.department_id),
        post_content: record.post_content,
        cover: [{
          uid: record.cover,
          name: 'img',
          url: record.cover_url,
          status: 'done',
        }],
        list_order: record.list_order,
      };
      this.$nextTick(() => {
        this.$refs.formRef.$refs.basicForm.form.setFieldsValue(data);
      });
    },
    // 确定编辑或新增
    handleSubmit() {
      this.$refs.formRef.$refs.basicForm.form.validateFields(
        async(err, values) => {
          if (!err) {
            console.log(values);
            this.btnIsLoading = true;
            values.cover= values.cover[0].uid;
            values.parent_id=values.parent_id;
            let result = await this.$http.post('/groups/update', {
              id: this.id,
              ...values,
            });
            this.btnIsLoading = false;
            if (result.data.status === 1) {
              this.visible = false;
              this.$message.success('操作成功！');
              this.$refs.formRef.$refs.basicForm.form.resetFields();
              this.getTableData({ keyword: this.keyword, department_id: this.department_id});
            }
          }
        }
      );
    },
    // 取消编辑或新增
    onCancel() {
      this.$refs.formRef.$refs.basicForm.form.resetFields();
      this.visible = false;
    },
    // 修改排序
    async onCellChange(id, key, value) {
      let result = await this.$http.post('/groups/listOrder', {
        id: id,
        list_order: Number(value),
      });
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.getTableData({ keyword: this.keyword, department_id: this.department_id});
      }
    },
    // 推荐
    async handleRecommend() {
      if(this.selectedRowKeys.length===0){
        this.isShowError=true;
        return ;
      }
      this.recommendLoading=true;
      let result = await this.$http.post('/groups/recommend', {
        ids: this.selectedRowKeys,
        recommended: 1,
      });
      this.recommendLoading=false;
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.selectedRowKeys=[];
        this.isShowError=false;
        this.getTableData({ keyword: this.keyword, department_id: this.department_id});
      }
    },
    // 取消推荐
    async handleNorecommend() {
      if(this.selectedRowKeys.length===0){
        this.isShowError=true;
        return ;
      }
      this.norecommendLoading=true;
      let result = await this.$http.post('/groups/recommend', {
        ids: this.selectedRowKeys,
        recommended: 0,
      });
      this.norecommendLoading=false;
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.selectedRowKeys=[];
        this.isShowError=false;
        this.getTableData({ keyword: this.keyword, department_id: this.department_id});
      }
    },
    // check表格
    onchangeCheck(selectedRowKeys, selectedRows){
      this.selectedRowKeys = selectedRowKeys;
    },
    // 禁用 启用
    async onConfirm(record) {
      let result = await this.$http.post('/groups/statusChange', {
        id: record.id,
        is_show: record.is_show === 1 ? 0 : 1,
      });
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.getTableData({ keyword: this.keyword, department_id: this.department_id});
      }
    },
    // 删除
    async onDelete(record) {
      let result = await this.$http.post('/groups/del', { id: record.id });
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.getTableData({ keyword: this.keyword, department_id: this.department_id});
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.column-container {
  .recommend-btn-container {
    margin-bottom: 10px;
    .recommend-btn {
      margin-right: 10px;
    }
    .errorMsg{
      color: red;
      font-size: 16px;
      margin-left: 10px;
    }
  }
  .editable-cell-container{
    width: 60%;
  }
}
</style>
